import React, { useState } from 'react';
import './App.css';
import { getApiBaseUrl } from './config/api';
import AdminNav from './components/AdminNav';
import Overview from './components/Overview';
import CaseStudies from './components/CaseStudies';
import ClientsDashboard from './components/ClientsDashboard';
import Testimonials from './components/Testimonials';
import Capabilities from './components/Capabilities';
import Industries from './components/Industries';
import Enquiries from './components/Enquiries';
import Team from './components/Team';
import Media from './components/Media';
import AuditLog from './components/AuditLog';
import Settings from './components/Settings';

export default function App() {
  const [currentPage, setCurrentPage] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('page') || 'case-studies';
  });
  const [navigationParams, setNavigationParams] = useState({});
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return !!localStorage.getItem('token');
  });
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });

  const handleNavigate = (page, params = {}) => {
    const url = new URL(window.location);
    url.searchParams.set('page', page);
    window.history.pushState({}, '', url);
    setNavigationParams(params);
    setCurrentPage(page);
  };

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && !user) {
      const stored = localStorage.getItem('user');
      if (stored) setUser(JSON.parse(stored));
    }
  }, [user]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setLoginError('Email and password required');
      return;
    }

    try {
      setLoading(true);
      setLoginError('');

      const response = await fetch(`${getApiBaseUrl()}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      if (!response.ok) {
        setLoginError(data.error || 'Login failed');
        return;
      }

      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      setUser(data.user);
      setIsAuthenticated(true);
      setEmail('');
      setPassword('');
    } catch (error) {
      setLoginError('Network error. Please try again.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    const url = new URL(window.location);
    url.searchParams.delete('page');
    window.history.pushState({}, '', url);
    setIsAuthenticated(false);
    setUser(null);
    setCurrentPage('case-studies');
  };

  if (!isAuthenticated) {
    return (
      <div className="login-container">
        <div className="login-box">
          <div className="login-header">
            <div className="brand-mark">K</div>
            <div>
              <h1>K Capital Technology</h1>
              <p>Admin Portal</p>
            </div>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            <label className="field">
              <span className="field__label">Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="andrew@k-capital.com.au"
                className="field__input"
                disabled={loading}
              />
            </label>

            <label className="field">
              <span className="field__label">Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="field__input"
                disabled={loading}
              />
            </label>

            {loginError && <div className="login-error">{loginError}</div>}

            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="login-footer">
            <p style={{ fontSize: '12px', color: 'var(--graphite-2)' }}>
              K Capital Admin Portal
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <AdminNav
        currentPage={currentPage}
        onPageChange={handleNavigate}
        onLogout={handleLogout}
        user={user}
      />

      <main className="admin-content">
        <div className="container">
          {currentPage === 'overview' && <Overview />}
          {currentPage === 'case-studies' && <CaseStudies />}
          {currentPage === 'clients' && <ClientsDashboard />}
          {currentPage === 'testimonials' && <Testimonials />}
          {currentPage === 'capabilities' && <Capabilities />}
          {currentPage === 'industries' && <Industries />}
          {currentPage === 'enquiries' && <Enquiries />}
          {currentPage === 'team' && <Team />}
          {currentPage === 'media' && <Media />}
          {currentPage === 'audit' && <AuditLog />}
          {currentPage === 'settings' && <Settings />}
        </div>
      </main>
    </div>
  );
}
